import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import './bootstrap.min.css'
import './index.css'

const TemplateWrapper = ({ children }) =>
  <div>
    <Helmet
      title="William Newton"
      meta={[
        { name: 'description', content: 'The work, writing, and art of William Newton' },
        { name: 'keywords', content: 'design, art, tech' },
      ]}
    />
    <div className="site-container">
      {children()}
    </div>
  </div>

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js